import { toast } from "sonner";
import { trpc } from "@/lib/trpc";

async function copiar(url: string, msg: string) {
  try {
    await navigator.clipboard.writeText(url);
    toast.success(msg);
  } catch {
    window.prompt("Copie o link do extrato:", url);
  }
}

/** Enviar por e-mail, copiar o link e trocar o link de um extrato — no extrato e na lista. */
export function useEnvioDoExtrato() {
  const utils = trpc.useUtils();
  const depois = () => {
    utils.financeiro.extratos.invalidate();
    utils.financeiro.envio.invalidate();
  };
  const enviar = trpc.financeiro.envio.enviar.useMutation({
    onSuccess: (r) => (toast.success(`Extrato enviado para ${r.para}.`), depois()),
    onError: (err) => toast.error(err.message),
  });
  const link = trpc.financeiro.envio.link.useMutation({
    onSuccess: (r) => (copiar(r.url, "Link copiado. Pode colar no WhatsApp."), depois()),
    onError: (err) => toast.error(err.message),
  });
  const novoLink = trpc.financeiro.envio.novoLink.useMutation({
    onSuccess: (r) => (copiar(r.url, "Link novo copiado. O anterior não abre mais."), depois()),
    onError: (err) => toast.error(err.message),
  });
  return { enviar, link, novoLink };
}
